import { useAuthenticator } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import { Button, Container, FormControl, Table } from "react-bootstrap";
import {
  FlipSettings,
  User,
  defaultFlipSettings,
  flipSettings,
} from "stubminer-logic/dist";
import { client } from "../App";
import { useProfileContext } from "../contexts/ProfileContexts";
import { putSettings, resetDeviceId } from "../graphql/mutations";
import { refreshMe } from "../utils";

interface PutSettingsReturn {
  data: {
    putSettings: {
      user: User;
    };
  };
}

const SettingsComponent = () => {
  const useAuthenticatorReturn = useAuthenticator();

  const cognitoUser = useAuthenticatorReturn.user;

  const { setProfile, setUser, user } = useProfileContext();

  useEffect(() => {
    console.log("cognito user", cognitoUser);
    if (cognitoUser) {
      refreshMe(setUser, setProfile);
    }
  }, [cognitoUser, setProfile, setUser]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const [localSettings, setLocalSettings] =
    useState<FlipSettings>(defaultFlipSettings);

  useEffect(() => {
    if (user?.settings?.data) {
      setLocalSettings(JSON.parse(user.settings.data));
    }
  }, [user]);

  const saveToDb = async () => {
    console.log({ user });
    if (user) {
      setLoading(true);
      setError("");
      try {
        (await client.graphql({
          query: putSettings,
          variables: {
            data: JSON.stringify(localSettings),
          },
        })) as PutSettingsReturn;
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
        }, 3000);
      } catch (e) {
        setError(`Did not save: ${JSON.stringify(e)}`);
      }
      setLoading(false);
    }
  };

  const handleResetDeviceId = async () => {
    if (user) {
      setLoading(true);
      setError("");
      try {
        await client.graphql({ query: resetDeviceId });
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
        }, 3000);
      } catch (e) {
        setError(`Did not save: ${JSON.stringify(e)}`);
      }
      setLoading(false);
    }
  };

  return (
    <Container>
      <h1 className="center">Settings</h1>
      <Button
        variant="primary"
        disabled={loading}
        onClick={handleResetDeviceId}
      >
        Reset Device Id
      </Button>
      <Table>
        <thead>
          <tr>
            <th>Setting</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {flipSettings.map((setting, index) => (
            <tr key={index}>
              <td>{setting.title}</td>
              <td>
                {setting.type === "select" && (
                  <FormControl
                    as="select"
                    value={localSettings[setting.name as keyof FlipSettings]}
                    onChange={(e) =>
                      setLocalSettings({
                        ...localSettings,
                        [setting.name]: e.target.value,
                      })
                    }
                    id={setting.name}
                    disabled={loading}
                  >
                    {setting.options!.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.text}
                      </option>
                    ))}
                  </FormControl>
                )}
                {setting.type === "number" && (
                  <FormControl
                    type="number"
                    step={setting.step}
                    value={localSettings[setting.name as keyof FlipSettings]}
                    onChange={(e) =>
                      setLocalSettings({
                        ...localSettings,
                        [setting.name]: e.target.value,
                      })
                    }
                    id={setting.name}
                    disabled={loading}
                  />
                )}
              </td>
            </tr>
          ))}
          <tr>
            <td colSpan={2}>
              <Button variant="primary" disabled={loading} onClick={saveToDb}>
                Save
              </Button>
              {error && <p className="error">{error}</p>}
              {success && <p className="success">Saved!</p>}
            </td>
          </tr>
        </tbody>
      </Table>
    </Container>
  );
};

export default SettingsComponent;
